var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSaveAsBlackIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "invisible_box",
    "data-name": "invisible box"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_143360",
    "data-name": "Rectangle 143360",
    width: 18,
    height: 18,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_143361",
    "data-name": "Rectangle 143361",
    width: 18,
    height: 18,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_143362",
    "data-name": "Rectangle 143362",
    width: 18,
    height: 18,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "icons_Q2",
    "data-name": "icons Q2",
    transform: "translate(1.5 1.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41011",
    "data-name": "Group 41011"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60331",
    "data-name": "Path 60331",
    d: "M15.25,4H4.75A.75.75,0,0,0,4,4.75v13.5a.75.75,0,0,0,.75.75h13.5a.75.75,0,0,0,.75-.75V7.75Zm-1.5,13.5H9.25V13h4.5Zm3.75,0H15.25V12.25a.75.75,0,0,0-.75-.75h-6a.75.75,0,0,0-.75.75V17.5H5.5V5.5h9.112L17.5,8.387Z",
    transform: "translate(-4 -4)",
    fill: "#3b5175"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60332",
    "data-name": "Path 60332",
    d: "M19.25,12h-4.5a.75.75,0,0,0,0,1.5h4.5a.75.75,0,0,0,0-1.5Z",
    transform: "translate(-10.25 -9)",
    fill: "#3b5175"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveAsBlackIcon);
export default __webpack_public_path__ + "static/media/save_as_black_icon.de977ea82f13a6c7cb0972431b498864.svg";
export { ForwardRef as ReactComponent };